
import BtnBack from "../../../../Button/BtnBack";
import FooterLogo from "../../../../Includes/Footer/FooterLogo";
import { Divider, Stack, Container } from "@mui/material";
import { withTheme } from "@emotion/react";
import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { CitStepIcon, CitStepConnector } from "./StepComponents";
import JobRequirements from "./JobRequirements";
import StepperBtnBack from '../../../../Button/StepperBtnBack '
import BtnSecondary from '../../../../Button/BtnSecondary'
import BtnPrimary from '../../../../Button/BtnPrimary'
import EmplymentInfo from "./EmplymentInfo";
import Availability from "./Availability";
import WorkExperience from "./WorkExperience";
import Acknowledgement from "./Acknowledgement";
import EmployabilityStatement from "./EmployabilityStatement";
import ReferenceRelease from "./ReferenceRelease";
import { useDialogContext } from "../../../../Context/DialogContext";

const steps = ['Job Requirements', 'Employement Information', 'Availability', 'Work experience', 'Acknowledgement', 'Employability Statement', 'Reference release'];

const JobApplication = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const { onOpen } = useDialogContext()


  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    scrollToTop()
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    scrollToTop()
  };

  const handleReset = () => {
    setActiveStep(0);
  };


  const handleSubmit = () => {
      onOpen("Your application has been submitted successfully")
      
  }



  const NavBar = () => {
    return (
      <Stack position={"relative"} justifyContent={'center'} pb={'24px'} direction="row">
        <BtnBack sx={{ position: {xs:'relative',sm:'absolute'}, left: {xs:'0px',sm:'58px',md:'96px'} }} height="56px" text={'Go back'} />
        <FooterLogo />
      </Stack>
    )
  }

  const scrollToTop = () => {
    document.body.scrollIntoView()
  }





  return (

    <Box sx={{ width: '100%' }}>
      <Stack>
        <NavBar />
        <Divider />
        <Container sx={{ maxWidth: 'xl', width: {xs:'100%',sm:'auto'}, paddingLeft: `16px !important`, paddingRight: `16px !important`, py: '24px', alignItems: 'center', display: "flex", flexDirection: 'column' }} >
          <Stepper alternativeLabel connector={<CitStepConnector />} sx={{ marginTop: '48px', width: '95%' }} activeStep={activeStep}>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};
              return (
                <Step
                  key={label} {...stepProps}>
                  <StepLabel StepIconComponent={CitStepIcon} {...labelProps}></StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {activeStep === steps.length ? (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                All steps completed - you&apos;re finished
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                <Box sx={{ flex: '1 1 auto' }} />
                <Button onClick={handleReset}>Reset</Button>
              </Box>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Box sx={{ width:{xs:'inherit',sm:'auto'}, display: 'flex', flexDirection: 'column', pt: 2 }}>

                {activeStep === 0 && <JobRequirements />}
                {activeStep === 1 && <EmplymentInfo />}
                {activeStep === 2 && <Availability/>}
                {activeStep === 3 && <WorkExperience/>}
                {activeStep === 4 && <Acknowledgement/>}
                {activeStep === 5 && <EmployabilityStatement/>}
                {activeStep === 6 && <ReferenceRelease/>}

                <Stack mt={'48px'} mx={{xs:'19px',sm:'60px',md:'85px'}} flexDirection={'row'} justifyContent={'space-between'}>
                 <StepperBtnBack hide={activeStep === 0 ?true:false} height={'48px'} handleClick={handleBack} text={'Go back'} />
                  {activeStep === steps.length - 1 ?
 
                    <BtnPrimary onClick={handleSubmit} height={'48px'} text={'Submit application'} /> :
                    <BtnSecondary height={'48px'} onClick={handleNext} text={'Go to next step'} />
                  }

                </Stack>
              </Box>
            </React.Fragment>
          )}
        </Container>
      </Stack>
    </Box>
  );
}




export default withTheme(JobApplication);